import * as XLSX from 'xlsx';
import { getBreakdownDisplayName } from '../_utils/analytics-formatters.util';
import * as i0 from "@angular/core";
var AnalyticsExportService = /** @class */ (function () {
    function AnalyticsExportService() {
    }
    /**
     * Export drink volume table to Excel
     */
    AnalyticsExportService.prototype.exportDrinkVolumeTable = function (data, filters, tabName, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        if (tabName === void 0) { tabName = 'Drink Volume'; }
        console.log('[Export Service] exportDrinkVolumeTable() called');
        console.log('[Export Service] Input data:', {
            labelsCount: data.labels.length,
            dataCount: data.data.length,
            hasCompareData: !!data.compareData,
            compareDataCount: data.compareData ? data.compareData.length : 0,
            firstColumnHeader: data.firstColumnHeader,
            secondColumnHeader: data.secondColumnHeader,
            thirdColumnHeader: data.thirdColumnHeader,
            total: data.total,
            compareTotal: data.compareTotal,
            retailRevenueTotal: data.retailRevenueTotal,
            compareRetailRevenueTotal: data.compareRetailRevenueTotal,
            breakdownBy: filters.breakdownBy
        });
        var workbook = XLSX.utils.book_new();
        // Create data sheet
        var sheetData = [];
        // Headers - use exact same headers as displayed in the table
        // First column: breakdown name (e.g., "Drink", "Distributor", "Client", "Campus", "Machine")
        // Second column: "Total" or "Average per Day/Week/Month" depending on averageEnabled
        // Third column (if compare enabled): "Previous Total" or "Previous Average per Day/Week/Month"
        var headers = [
            data.firstColumnHeader || getBreakdownDisplayName(filters.breakdownBy),
            data.secondColumnHeader || 'Total'
        ];
        if (data.thirdColumnHeader) {
            headers.push(data.thirdColumnHeader);
        }
        if (data.retailRevenueData) {
            headers.push(data.retailRevenueHeader || 'Retail Revenue');
        }
        if (data.compareRetailRevenueData) {
            headers.push(data.compareRetailRevenueHeader || 'Previous Retail Revenue');
        }
        sheetData.push(headers);
        console.log('[Export Service] Headers created:', headers);
        // Data rows
        console.log('[Export Service] Creating data rows, count:', data.labels.length);
        for (var i = 0; i < data.labels.length; i++) {
            var row = [data.labels[i], data.data[i]];
            if (data.compareData && data.compareData[i] !== undefined) {
                row.push(data.compareData[i]);
            }
            if (data.retailRevenueData) {
                row.push(data.retailRevenueData[i] || 0);
            }
            if (data.compareRetailRevenueData) {
                row.push(data.compareRetailRevenueData[i] || 0);
            }
            sheetData.push(row);
        }
        console.log('[Export Service] Data rows created, total rows:', sheetData.length);
        // Totals row
        var totalsRow = ['Total', data.total];
        if (data.compareTotal !== undefined) {
            totalsRow.push(data.compareTotal);
        }
        if (data.retailRevenueTotal !== undefined) {
            totalsRow.push(data.retailRevenueTotal);
        }
        if (data.compareRetailRevenueTotal !== undefined) {
            totalsRow.push(data.compareRetailRevenueTotal);
        }
        sheetData.push(totalsRow);
        console.log('[Export Service] Totals row added:', totalsRow);
        var ws = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, ws, tabName);
        console.log('[Export Service] Data sheet created and added to workbook');
        // Add metadata sheet
        this.addMetadataSheet(workbook, 'drink-volume', filters, undefined, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        console.log('[Export Service] Metadata sheet added');
        // Generate filename and save
        var fileName = this.generateFileName('Drink_Volume', filters.breakdownBy, filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        console.log('[Export Service] Generated filename:', fileName);
        console.log('[Export Service] Attempting to save file...');
        XLSX.writeFile(workbook, fileName);
        console.log('[Export Service] File saved successfully');
    };
    /**
     * Export consumption table to Excel
     */
    AnalyticsExportService.prototype.exportConsumptionTable = function (data, filters, tabName, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        if (tabName === void 0) { tabName = 'Consumption'; }
        var workbook = XLSX.utils.book_new();
        // Create data sheet
        var sheetData = [];
        // Headers
        var breakdownName = data.breakdownBy !== 'product'
            ? getBreakdownDisplayName(data.breakdownBy)
            : 'Product';
        var headers = [breakdownName];
        if (data.isStacked) {
            // Stacked format: one column per product
            data.data.forEach(function (dataset) {
                headers.push(dataset.label || '');
            });
        }
        else {
            // Simple format: Current (lbs) and optionally Previous (lbs)
            headers.push('Current (lbs)');
            if (data.compareData && data.compareData.length > 0) {
                headers.push('Previous (lbs)');
            }
        }
        sheetData.push(headers);
        // Data rows
        var labelCount = data.labels.length;
        var _loop_1 = function (i) {
            var row = [data.labels[i]];
            if (data.isStacked) {
                // Stacked: one value per product dataset
                data.data.forEach(function (dataset) {
                    var value = dataset.data[i] || 0;
                    row.push(value);
                });
            }
            else {
                // Simple: current value and optionally compare value
                var currentValue = (data.data[0] && data.data[0].data) ? data.data[0].data[i] || 0 : 0;
                row.push(currentValue);
                if (data.compareData && data.compareData[i] !== undefined) {
                    row.push(data.compareData[i]);
                }
            }
            sheetData.push(row);
        };
        for (var i = 0; i < labelCount; i++) {
            _loop_1(i);
        }
        // Totals row
        var totalsRow = ['Total'];
        if (data.isStacked) {
            data.data.forEach(function (dataset) {
                var total = dataset.data.reduce(function (sum, val) { return sum + (val || 0); }, 0);
                totalsRow.push(total);
            });
        }
        else {
            totalsRow.push(data.total);
            if (data.compareTotal !== undefined) {
                totalsRow.push(data.compareTotal);
            }
        }
        sheetData.push(totalsRow);
        var ws = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, ws, tabName);
        // Add metadata sheet
        this.addMetadataSheet(workbook, 'consumption', filters, undefined, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        // Generate filename and save
        var fileName = this.generateFileName('Consumption', filters.breakdownBy, filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        XLSX.writeFile(workbook, fileName);
    };
    /**
     * Export forecast tables to Excel (all 3 tables as separate sheets)
     */
    AnalyticsExportService.prototype.exportForecastTable = function (data, filters, forecastDays, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        var workbook = XLSX.utils.book_new();
        // Sheet 1: Projected Consumption by Product
        var projectedSheetData = [];
        var breakdownName = data.projectedConsumption.breakdownBy !== 'product'
            ? getBreakdownDisplayName(data.projectedConsumption.breakdownBy)
            : 'Product';
        var projectedHeaders = [breakdownName];
        if (data.projectedConsumption.isStacked) {
            data.projectedConsumption.data.forEach(function (dataset) {
                projectedHeaders.push(dataset.label || '');
            });
        }
        else {
            projectedHeaders.push('Projected (lbs)');
        }
        projectedSheetData.push(projectedHeaders);
        var _loop_2 = function (i) {
            var row = [data.projectedConsumption.labels[i]];
            if (data.projectedConsumption.isStacked) {
                data.projectedConsumption.data.forEach(function (dataset) {
                    var value = dataset.data[i] || 0;
                    row.push(value);
                });
            }
            else {
                var value = (data.projectedConsumption.data[0] && data.projectedConsumption.data[0].data)
                    ? data.projectedConsumption.data[0].data[i] || 0
                    : 0;
                row.push(value);
            }
            projectedSheetData.push(row);
        };
        // Data rows
        for (var i = 0; i < data.projectedConsumption.labels.length; i++) {
            _loop_2(i);
        }
        // Totals row
        var projectedTotalsRow = ['Total'];
        if (data.projectedConsumption.isStacked) {
            data.projectedConsumption.data.forEach(function (dataset) {
                var total = dataset.data.reduce(function (sum, val) { return sum + (val || 0); }, 0);
                projectedTotalsRow.push(total);
            });
        }
        else {
            projectedTotalsRow.push(data.projectedConsumption.total);
        }
        projectedSheetData.push(projectedTotalsRow);
        var projectedWs = XLSX.utils.aoa_to_sheet(projectedSheetData);
        XLSX.utils.book_append_sheet(workbook, projectedWs, 'Projected Consumption');
        // Sheet 2: Inventory Projection Summary
        var inventorySheetData = [
            ['Product', 'Current (lbs)', 'Projected End (lbs)']
        ];
        data.inventoryProjection.table.forEach(function (row) {
            inventorySheetData.push([
                row.product,
                row.current,
                row.projectedEnd
            ]);
        });
        inventorySheetData.push([
            'Total',
            data.inventoryProjection.currentTotal,
            data.inventoryProjection.endTotal
        ]);
        var inventoryWs = XLSX.utils.aoa_to_sheet(inventorySheetData);
        XLSX.utils.book_append_sheet(workbook, inventoryWs, 'Inventory Projection Summary');
        // Sheet 3: Projected Consumption Over Time
        var timeSeriesSheetData = [];
        var timeSeriesHeaders = ['Date'];
        data.projectedConsumptionOverTime.datasets.forEach(function (dataset) {
            timeSeriesHeaders.push(dataset.label || '');
        });
        timeSeriesSheetData.push(timeSeriesHeaders);
        var _loop_3 = function (i) {
            var row = [data.projectedConsumptionOverTime.labels[i]];
            data.projectedConsumptionOverTime.datasets.forEach(function (dataset) {
                var value = dataset.data[i] || 0;
                row.push(value);
            });
            timeSeriesSheetData.push(row);
        };
        // Data rows
        for (var i = 0; i < data.projectedConsumptionOverTime.labels.length; i++) {
            _loop_3(i);
        }
        // Totals row
        var timeSeriesTotalsRow = ['Total'];
        data.projectedConsumptionOverTime.totals.forEach(function (total) {
            timeSeriesTotalsRow.push(total);
        });
        timeSeriesSheetData.push(timeSeriesTotalsRow);
        var timeSeriesWs = XLSX.utils.aoa_to_sheet(timeSeriesSheetData);
        XLSX.utils.book_append_sheet(workbook, timeSeriesWs, 'Projected Consumption Over Time');
        // Add metadata sheet
        this.addMetadataSheet(workbook, 'forecast', filters, forecastDays, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        // Generate filename and save
        var fileName = this.generateFileName('Forecast', filters.breakdownBy, filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        XLSX.writeFile(workbook, fileName);
    };
    /**
     * Export stockouts table to Excel
     */
    AnalyticsExportService.prototype.exportStockoutsTable = function (data, filters, tabName, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        if (tabName === void 0) { tabName = 'Stock-outs'; }
        var workbook = XLSX.utils.book_new();
        // Create data sheet
        var sheetData = [
            ['Machine', 'Product', 'Inventory (lbs)', 'Days Until Empty', 'Risk']
        ];
        // Data rows
        data.rows.forEach(function (row) {
            sheetData.push([
                row.machine,
                row.product,
                row.inventory,
                row.daysLeft,
                row.risk
            ]);
        });
        var ws = XLSX.utils.aoa_to_sheet(sheetData);
        XLSX.utils.book_append_sheet(workbook, ws, tabName);
        // Add metadata sheet
        this.addMetadataSheet(workbook, 'stockouts', filters, undefined, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        // Generate filename and save
        var fileName = this.generateFileName('Stockouts', 'product', filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        XLSX.writeFile(workbook, fileName);
    };
    /**
     * Generate filename based on tab, breakdown, and filters
     */
    AnalyticsExportService.prototype.generateFileName = function (tabName, breakdown, filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        var breakdownDisplay = getBreakdownDisplayName(breakdown);
        var mostSpecificFilter = this.getMostSpecificFilter(filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions);
        var dateStr = new Date().toISOString().split('T')[0];
        var fileName = tabName + "_" + breakdownDisplay;
        if (mostSpecificFilter) {
            fileName += "_" + mostSpecificFilter;
        }
        fileName += "_" + dateStr + ".xlsx";
        return fileName;
    };
    /**
     * Get the most specific filter for filename (Machine > Campus > Client > Market > Distributor)
     * Returns labels instead of IDs, joined with hyphens
     */
    AnalyticsExportService.prototype.getMostSpecificFilter = function (filters, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        var _this = this;
        // Check in order of specificity
        if (filters.machines && filters.machines.length > 0) {
            var labels = this.convertIdsToLabels(filters.machines, machineOptions);
            // Sanitize labels for filename (remove invalid characters)
            return labels.map(function (label) { return _this.sanitizeForFilename(label); }).join('-');
        }
        if (filters.campuses && filters.campuses.length > 0) {
            var labels = this.convertIdsToLabels(filters.campuses, campusOptions);
            return labels.map(function (label) { return _this.sanitizeForFilename(label); }).join('-');
        }
        if (filters.clients && filters.clients.length > 0) {
            var labels = this.convertIdsToLabels(filters.clients, clientOptions);
            return labels.map(function (label) { return _this.sanitizeForFilename(label); }).join('-');
        }
        if (filters.markets && filters.markets.length > 0) {
            var labels = this.convertIdsToLabels(filters.markets, marketOptions);
            return labels.map(function (label) { return _this.sanitizeForFilename(label); }).join('-');
        }
        if (filters.distributors && filters.distributors.length > 0) {
            var labels = this.convertIdsToLabels(filters.distributors, distributorOptions);
            return labels.map(function (label) { return _this.sanitizeForFilename(label); }).join('-');
        }
        return '';
    };
    /**
     * Sanitize a string for use in a filename
     * Removes or replaces invalid filename characters
     */
    AnalyticsExportService.prototype.sanitizeForFilename = function (str) {
        // Replace invalid filename characters with underscores
        // Invalid characters: / \ : * ? " < > |
        return str.replace(/[\/\\:*?"<>|]/g, '_').trim();
    };
    /**
     * Add metadata sheet to workbook
     */
    AnalyticsExportService.prototype.addMetadataSheet = function (workbook, tabKey, filters, forecastDays, drinkOptions, productOptions, distributorOptions, marketOptions, clientOptions, campusOptions, machineOptions) {
        var metadata = [
            ['Field', 'Value']
        ];
        // Tab name
        var tabNames = {
            'drink-volume': 'Drink Volume',
            'consumption': 'Consumption',
            'forecast': 'Forecast',
            'stockouts': 'Stock-outs'
        };
        metadata.push(['Tab Name', tabNames[tabKey] || tabKey]);
        // Breakdown type (skip for stockouts)
        if (tabKey !== 'stockouts') {
            metadata.push(['Breakdown Type', getBreakdownDisplayName(filters.breakdownBy)]);
        }
        // Date range (skip for stockouts)
        if (tabKey !== 'stockouts') {
            var dateRange = 'N/A';
            if (filters.startDate && filters.endDate) {
                var startDate = this.formatDate(filters.startDate);
                var endDate = this.formatDate(filters.endDate);
                dateRange = startDate + " to " + endDate;
            }
            else if (filters.datePreset) {
                var presetLabels = {
                    '7': 'Last 7 days',
                    '30': 'Last 30 days',
                    '90': 'Last 90 days',
                    '365': 'Last year',
                    'custom': 'Custom'
                };
                dateRange = presetLabels[filters.datePreset] || filters.datePreset;
            }
            metadata.push(['Date Range', dateRange]);
        }
        // Selected filters - use labels instead of IDs
        if (filters.distributors && filters.distributors.length > 0) {
            var distributorLabels = this.convertIdsToLabels(filters.distributors, distributorOptions);
            metadata.push(['Selected Distributors', distributorLabels.join(', ')]);
        }
        if (filters.markets && filters.markets.length > 0) {
            var marketLabels = this.convertIdsToLabels(filters.markets, marketOptions);
            metadata.push(['Selected Markets', marketLabels.join(', ')]);
        }
        if (filters.clients && filters.clients.length > 0) {
            var clientLabels = this.convertIdsToLabels(filters.clients, clientOptions);
            metadata.push(['Selected Clients', clientLabels.join(', ')]);
        }
        if (filters.campuses && filters.campuses.length > 0) {
            var campusLabels = this.convertIdsToLabels(filters.campuses, campusOptions);
            metadata.push(['Selected Campuses', campusLabels.join(', ')]);
        }
        if (filters.machines && filters.machines.length > 0) {
            var machineLabels = this.convertIdsToLabels(filters.machines, machineOptions);
            metadata.push(['Selected Machines', machineLabels.join(', ')]);
        }
        if (filters.products && filters.products.length > 0) {
            var productLabels = this.convertIdsToLabels(filters.products, productOptions);
            metadata.push(['Selected Products', productLabels.join(', ')]);
        }
        if (filters.drinks && filters.drinks.length > 0) {
            var drinkLabels = this.convertIdsToLabels(filters.drinks, drinkOptions);
            metadata.push(['Selected Drinks', drinkLabels.join(', ')]);
        }
        // Compare mode (skip for stockouts)
        if (tabKey !== 'stockouts') {
            metadata.push(['Compare Mode Enabled', filters.compareEnabled ? 'Yes' : 'No']);
        }
        // Average settings (if applicable - only for drink-volume and consumption)
        if (tabKey === 'drink-volume' || tabKey === 'consumption') {
            metadata.push(['Average Enabled', filters.averageEnabled ? 'Yes' : 'No']);
            if (filters.averageEnabled) {
                metadata.push(['Average By', filters.avgBy.charAt(0).toUpperCase() + filters.avgBy.slice(1)]);
            }
        }
        // Forecast days (for forecast tab)
        if (tabKey === 'forecast' && forecastDays !== undefined) {
            metadata.push(['Forecast Days', forecastDays.toString()]);
        }
        // Export timestamp
        metadata.push(['Export Timestamp', new Date().toLocaleString('en-US')]);
        var ws = XLSX.utils.aoa_to_sheet(metadata);
        XLSX.utils.book_append_sheet(workbook, ws, 'Metadata');
    };
    /**
     * Format date string for display (same format as UI)
     */
    AnalyticsExportService.prototype.formatDate = function (dateStr) {
        try {
            var date = new Date(dateStr);
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
        }
        catch (_a) {
            return dateStr;
        }
    };
    /**
     * Convert filter IDs to display labels using options
     */
    AnalyticsExportService.prototype.convertIdsToLabels = function (ids, options) {
        if (!options || options.length === 0) {
            return ids; // Fallback to IDs if options not available
        }
        return ids.map(function (id) {
            var option = options.find(function (opt) { return String(opt.value) === String(id); });
            return option ? option.label : id; // Use label if found, otherwise fallback to ID
        });
    };
    AnalyticsExportService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsExportService_Factory() { return new AnalyticsExportService(); }, token: AnalyticsExportService, providedIn: "root" });
    return AnalyticsExportService;
}());
export { AnalyticsExportService };
